import React from "react";
import OwS3Uploader from "@components/shared/OwS3Uploader/OwS3Uploader";
import OwButton from "@components/shared/OwButton/OwButton";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import FileUploadResourceTypeEnum from "@models/FileUploadResourceTypeEnum";
import S3UploadTypeEnum from "@models/S3UploadTypeEnum";
import { useAppContextNonNull } from "@contexts/AppContext";
import "./AccountNotesCsvUploadModal.scss";

type Props = {
    closeModalFn: () => void;
};

export const AccountNotesCsvUploadModal: React.FC<Props> = ({ closeModalFn }) => {
    const { userModel, supplierModel, socket } = useAppContextNonNull();

    return (
        <div className="AccountNotesCsvUploadModal p-2">
            <div className={"d-flex justify-content-between"}>
                <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_csv"} tag={"h3"} />
                <div>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModalFn} />
                </div>
            </div>

            <div className={"mt-3 border-dashed"}>
                <OwS3Uploader
                    resourceType={FileUploadResourceTypeEnum.bulkNotesCsv}
                    socket={socket}
                    isReadOnly={false}
                    dropOnly={false}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    isS3Upload={true}
                    s3UploadType={S3UploadTypeEnum.BULK_NOTES_CSV}
                />
            </div>
        </div>
    );
};
